module.exports = __webpack_public_path__ + "static/receipt-a571b82a4d9f8ac00ba10b8ac6881837.png";